import { render, staticRenderFns } from "./ModalCreateBanner.vue?vue&type=template&id=b84680a0&scoped=true"
import script from "./ModalCreateBanner.vue?vue&type=script&lang=js"
export * from "./ModalCreateBanner.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateBanner.vue?vue&type=style&index=0&id=b84680a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84680a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VImg})
